export default __webpack_public_path__ + "static/media/bcn.cedd6f75.svg";